//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Loading from '@/components/views/loading'
import Service from '@/service/chat'
import pagination from '@/common/mixins/pagination'
export default {
    mixins: [
        pagination
    ],
    data () {
        return {
            loading: true,
            items: []
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            Service.getHistory(this.page).then(this.handleData)
        },
        goChat (e) {
            const { id } = e.currentTarget.dataset
            wx.navigateTo({
                url: `/chat_list/chat?session_id=${id}`
            })
        }
    },
    components: {
        Loading
    }
}
